import React, { FC, useEffect } from 'react'
import styles from 'styles/components/template.module.scss'
import text from 'styles/utility/text.module.scss'
import classNames from 'classnames'
import { State } from 'index'
import { useSelector } from 'react-redux'
import { Spacer } from 'components/Utility'
import { Description, MainHeadline } from 'components/Typography'
import { CautionCard, MonthlyReportCard } from 'components/Card'
import { getStoreRef } from 'reducks/auth/selectors'
import { useQueryMonthlyReport } from 'hooks/revenue'

type Props = {
  headline: string
  datetime: Date
  yearMonth: string | undefined
}

const MonthlyReportDetailPrintTemplate: FC<Props> = (props) => {
  const { headline, datetime, yearMonth } = props
  const storeRef = useSelector((state: State) => getStoreRef(state))
  const year = yearMonth ? Number(yearMonth.slice(0, 4)) : undefined
  const month = yearMonth ? Number(yearMonth.slice(4, 6)) : undefined
  // レポートの値を展開
  const { report, hasError } = useQueryMonthlyReport(storeRef.id, year, month)
  const couponAmount = report?.report.coupon?.amount || 0
  const amount = report?.report.amount || 0
  const feeAmount = report?.report.fee_amount || 0
  const total = amount - feeAmount + couponAmount

  useEffect(() => {
    if (!report) return
    window.print()
  }, [report])

  return (
    <div className={styles.standard}>
      <Spacer size={28} />
      <MainHeadline headline={headline} />
      <Spacer size={28} />
      {hasError ? (
        <CautionCard
          caution={'売上レポートを取得できませんでした'}
          description={
            'お手数ですが、時間をおいて再度お試しください。\n' + '解消しない場合はサポートまでお問い合わせください。'
          }
          size={'small'}
        />
      ) : (
        <>
          <Description
            description={
              'いつもお引き立てを賜り厚く御礼申し上げます。\n' +
              '当該期間における貴店のsacriでの売上は下記の通りとなっております。'
            }
          />
          <Spacer size={24} />
          <MonthlyReportCard
            amount={amount}
            couponAmount={couponAmount}
            datetime={datetime}
            feeAmount={feeAmount}
            storeNames={report?.store_names || []}
            taxBreakdown={report?.report.tax_breakdown}
            total={total}
          />
          <Spacer size={12} />
          <Description
            description={
              'この度はご利用頂き誠にありがとうございました。\n' +
              '引き続き、sacriを何卒宜しくお願い致します。\n' +
              '※貴店売上よりクーポン利用による補填金額を還付し、sacri手数料及び手数料に関わる消費税を引いた金額が手数料控除後売上額となります。'
            }
          />
        </>
      )}
    </div>
  )
}

export default MonthlyReportDetailPrintTemplate
